import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Modal, Button, Form, InputGroup } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { fetchPaymentAccounts } from '../../../../services/api/chartRolesApi';

const PaymentReceivedModal = ({ show, handleClose, invoiceData, handlePaymentSubmit }) => {
    const { companyId } = useParams();
    const isCredit = invoiceData.invoice_type === 'credit_note';
    const [paymentDate, setPaymentDate] = useState(new Date());
    const [paidAmount, setPaidAmount] = useState(Math.abs(invoiceData.totals.grand_total)); // Show positive amount in input
    const [selectedAccount, setSelectedAccount] = useState('');
    // The tenant's own betalkonton — never a hardcoded option list.
    const [paymentAccounts, setPaymentAccounts] = useState([]);

    useEffect(() => {
        if (!show || !companyId) return undefined;
        let active = true;
        fetchPaymentAccounts(companyId)
            .then((accounts) => { if (active) setPaymentAccounts(accounts); })
            .catch(() => { if (active) setPaymentAccounts([]); });
        return () => { active = false; };
    }, [show, companyId]);

    const handleAccountChange = (e) => {
        setSelectedAccount(e.target.value);
    };

    const handleSubmit = () => {
        // Convert amount to negative for credit notes before submitting
        const submittedAmount = isCredit ? -Math.abs(paidAmount) : Math.abs(paidAmount);

        handlePaymentSubmit({
            paymentDate,
            paidAmount: submittedAmount,
            selectedAccount,
        });
        handleClose();
    };

    return (
        <Modal show={show} onHide={handleClose} size="md" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    {isCredit ? 'Registrera återbetalning' : 'Registrera betalning av faktura'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h5>Fakturanummer: {invoiceData.invoicenumber}</h5>
                <p>Kund: {invoiceData.customername}</p>

                <hr />

                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>{isCredit ? 'Återbetalningsdatum' : 'Betaldatum'}</Form.Label>
                        <DatePicker
                            selected={paymentDate}
                            onChange={(date) => setPaymentDate(date)}
                            className="form-control"
                            dateFormat="yyyy-MM-dd"
                            minDate={new Date(invoiceData.invoicedate)}
                            maxDate={new Date()}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>{isCredit ? 'Återbetalningssumma' : 'Summa'}</Form.Label>
                        <InputGroup>
                            <Form.Control
                                type="number"
                                value={paidAmount}
                                onChange={(e) => setPaidAmount(e.target.value)}
                                min="0"
                                max={Math.abs(invoiceData.totals.grand_total)}
                                step="0.01"
                                placeholder={isCredit ? "Ange återbetalningsbelopp" : "Ange betalningsbelopp"}
                            />
                            <InputGroup.Text>kr</InputGroup.Text>
                        </InputGroup>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>
                            {isCredit ? 'Återbetalt från konto' : 'Betalt till konto'}
                        </Form.Label>
                        <Form.Control
                            as="select"
                            value={selectedAccount}
                            onChange={handleAccountChange}
                        >
                            <option value="">Välj konto</option>
                            {paymentAccounts.map((account) => (
                                <option key={account.accountNumber} value={account.accountNumber}>
                                    {account.accountNumber} - {account.accountName}
                                </option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Avbryt
                </Button>
                <Button
                    variant="primary"
                    onClick={handleSubmit}
                    disabled={!selectedAccount || !paidAmount}
                >
                    {isCredit ? 'Bekräfta återbetalning' : 'Bekräfta'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PaymentReceivedModal;